import { Fancybox } from "@fancyapps/ui";

Fancybox.bind('[data-fancybox]', {
    Carousel: {
        transition: 'slide',
    },
    Images: {
        protected: true,
    },
    Toolbar: {
        display: {
            left: [
                'infobar',
            ],
            middle: [],
            right: [
                'iterateZoom',
                'slideshow',
                // 'fullscreen',
                // 'download',
                'thumbs',
                'close'
            ],
        },
    },
});
